import axios from 'axios'
import apiConfig from '@/config/api-config'
import { processErrorMessages } from './api-errors'
import { alertError } from './sweetalert'

const axiosHttp = axios.create({
  baseURL: apiConfig.API_BASE_URL
})

const DEBUG = process.env.VUE_APP_DEBUG_MODE

axiosHttp.interceptors.response.use(
  function(response) {
    if (DEBUG) console.info('RESPONSE SUCCESS: ', response)

    return response
  },
  function(error) {
    if (DEBUG) console.error('RESPONSE ERROR: ', error.response)

    const alert = processErrorMessages(error)
console.log(alert)
    if (alert.showAlert) alertError(alert.alertOptions)

    return Promise.reject(error)
  }
)

export default axiosHttp
